import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a3c1787&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2a3c1787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c1787",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3c1787')) {
      api.createRecord('2a3c1787', component.options)
    } else {
      api.reload('2a3c1787', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a3c1787&scoped=true&", function () {
      api.rerender('2a3c1787', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomService/index.vue"
export default component.exports